import React, { useEffect, useState } from "react";
import _ from "lodash";
import { EVENT_PLANNING_FLOOR_CAPACITY } from "../../../plannerConfig";
import {
  MultiWeekPlannerMainContainer,
  VisualisationSection,
} from "../multiWeekStyles.common";
import Visualisation from "../../Visualisations";
import LoadSpinnerOverlay from "../../LoadSpinner";

const FloorCapacity = ({
  api,
  store,
  fromDate,
  toDate,
  fromDateFilter,
  toDateFilter,
  durationAggregator,
  selectedScenarios,
  scenarioStringBuilder,
}) => {
  const { data, loadingQueue } = store[EVENT_PLANNING_FLOOR_CAPACITY];
  const [aPrefConfig, setAPrefConfig] = useState("line");
  const [bPrefConfig, setBPrefConfig] = useState("line");

  const getFloorCapacity = () => {
    const { get } = api;
    if (fromDate && toDate) {
      get([EVENT_PLANNING_FLOOR_CAPACITY], {
        routeParams: {
          fromDate,
          toDate,
          fromDateFilter,
          toDateFilter,
          durationAggregator,
          scenarios: scenarioStringBuilder(selectedScenarios),
        },
      });
    }
  };

  useEffect(() => {
    getFloorCapacity();
  }, [
    fromDate,
    toDate,
    durationAggregator,
    fromDateFilter,
    toDateFilter,
    selectedScenarios,
  ]);

  if (loadingQueue.length || _.isEmpty(data)) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <LoadSpinnerOverlay
          text="Floor Capacity Data Loading..."
          spinning={true}
        />
      </div>
    );
  }

  const { GraphA, GraphB } = data;

  const visualisationA = {
    ...GraphA,
    data: GraphA,
    prefConfig: aPrefConfig,
    onChangePrefConfig: (value) => setAPrefConfig(value),
  };

  const visualisationB = {
    ...GraphB,
    data: GraphB,
    prefConfig: bPrefConfig,
    onChangePrefConfig: (value) => setBPrefConfig(value),
  };

  return (
    <MultiWeekPlannerMainContainer>
      <div
        style={{
          display: "flex",
          flex: "1",
          margin: "1em",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
          padding: "0.5em",
        }}
      >
        <VisualisationSection>
          <Visualisation {...visualisationA} />
        </VisualisationSection>
      </div>
      <div
        style={{
          display: "flex",
          flex: "1",
          margin: "1em",
          border: "1px solid #d9d9d9",
          borderRadius: "10px",
          padding: "0.5em",
        }}
      >
        <VisualisationSection>
          <Visualisation {...visualisationB} />
        </VisualisationSection>
      </div>
    </MultiWeekPlannerMainContainer>
  );
};

export default FloorCapacity;
